/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd'; // export interface EuiDragDropContextProps extends DragDropContextProps {}

export var EuiDragDropContextContext = React.createContext({
  isDraggingType: null
});
export var EuiDragDropContext = ({
  onBeforeDragStart,
  onDragStart,
  onDragUpdate,
  onDragEnd,
  children,
  ...rest
}) => {
  const [isDraggingType, setIsDraggingType] = useState(null);

  const euiOnDragStart = (start, provided) => {
    setIsDraggingType(start.type);

    if (onDragStart) {
      onDragStart(start, provided);
    }
  };

  const euiOnDragEnd = (result, provided) => {
    setIsDraggingType(null);

    if (onDragEnd) {
      onDragEnd(result, provided);
    }
  };

  return <DragDropContext onBeforeDragStart={onBeforeDragStart} onDragStart={euiOnDragStart} onDragUpdate={onDragUpdate} onDragEnd={euiOnDragEnd} {...rest}>
      <EuiDragDropContextContext.Provider value={{
      isDraggingType
    }}>
        {children}
      </EuiDragDropContextContext.Provider>
    </DragDropContext>;
};

try {
  // @ts-ignore
  EuiDragDropContext.displayName = "EuiDragDropContext"; // @ts-ignore

  EuiDragDropContext.__docgenInfo = {
    "description": "",
    "displayName": "EuiDragDropContext",
    "props": {
      "onBeforeCapture": {
        "defaultValue": null,
        "description": "",
        "name": "onBeforeCapture",
        "required": false,
        "type": {
          "name": "((before: BeforeCapture) => void) | undefined"
        }
      },
      "onBeforeDragStart": {
        "defaultValue": null,
        "description": "",
        "name": "onBeforeDragStart",
        "required": false,
        "type": {
          "name": "((initial: DragStart) => void) | undefined"
        }
      },
      "onDragStart": {
        "defaultValue": null,
        "description": "",
        "name": "onDragStart",
        "required": false,
        "type": {
          "name": "((initial: DragStart, provided: ResponderProvided) => void) | undefined"
        }
      },
      "onDragUpdate": {
        "defaultValue": null,
        "description": "",
        "name": "onDragUpdate",
        "required": false,
        "type": {
          "name": "((initial: DragUpdate, provided: ResponderProvided) => void) | undefined"
        }
      },
      "onDragEnd": {
        "defaultValue": null,
        "description": "",
        "name": "onDragEnd",
        "required": true,
        "type": {
          "name": "(result: DropResult, provided: ResponderProvided) => void"
        }
      },
      "sensors": {
        "defaultValue": null,
        "description": "",
        "name": "sensors",
        "required": false,
        "type": {
          "name": "Sensor[] | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/drag_and_drop/drag_drop_context.tsx#EuiDragDropContext"] = {
      docgenInfo: EuiDragDropContext.__docgenInfo,
      name: "EuiDragDropContext",
      path: "src/components/drag_and_drop/drag_drop_context.tsx#EuiDragDropContext"
    };
} catch (__react_docgen_typescript_loader_error) {}